import {
	Component,
	OnInit,
	AfterViewInit,
	ViewChild,
	ViewEncapsulation,
	ElementRef
} from "@angular/core";
//import { AuthHttp } from 'angular2-jwt';
import { Subscription, Subject } from "rxjs";
//local
import { CheckoutService } from "./checkout.service";
// //Payment
import { LineItem, PaymentService, ProductSubType } from "@acepteam/payment";
import { PaymentComponent } from "@acepteam/payment";
import {
	PaymentSummary,
	PaymentUIConfiguration,
	OrderDetails,
	CustType,
	GPOrgCode,
	OrderSource,
	OrderTypeCode,
	OrgCode,
	CardType,
	PaymentType
} from "@acepteam/payment";
//global
import * as acepglobal from "@acepteam/globalspack";
import { DataService, LoggerService } from "../../../core/services";
import { MemberAppDataService, EmailHelperService } from "../../services";
import { NotifyInfo } from "../../../shared/models";
import { NotificationStatus, MemberType } from "../../../shared/enums/data.enums";
import { $ } from "../../../../../node_modules/protractor";
import { MyAccountDataOpsService } from "../../services/my-account-dataops.service";
import { debounceTime } from "rxjs/operators";
import { MembershipRate } from "src/app/shared/enums/xrm.constants";
import { GraduatingResidentOption } from "src/app/shared/models/my-account-data.models";

declare var window: any;

@Component({
	selector: "app-checkout",
	templateUrl: "./checkout.component.html",
	styleUrls: ["./checkout.component.scss"],
	encapsulation: ViewEncapsulation.None
	//   styleUrls: ['./checkout.component.scss', './resources/css/shoppingcart.css', './resources/css/temp.css', './resources/css/dd.css',
	// '../../../../../../../../globalassets/css/vandelay.css'
	// ]
})
export class CheckoutComponent implements OnInit, AfterViewInit {
	totalamount: any;
	orderNumber: string = "";
	maskedccnum: string = "";
	pingResponseFromClientRxd: boolean = false;
	subscriptions: Array<Subscription> = [];
	usercontext: any = null;
	termsAndConditionsText: string = "";
	cycleStartDate; cycleEndDate;
	isEMRAProRateMode: boolean = false;
	isRegYR123: boolean = false;
	isGraduatingResidentOrFellow: boolean = false;
	gresOptions: GraduatingResidentOption[] = null;

	modelChanged = new Subject<string>();

	paymentsummary: PaymentSummary = new PaymentSummary();
	paymentuiconfig: PaymentUIConfiguration = new PaymentUIConfiguration();
	orderdetails: OrderDetails;
	isClientCallbackAvailable: boolean = false;
	CardType: typeof CardType = CardType;
	PaymentType: typeof PaymentType = PaymentType;
	ProductSubType: typeof ProductSubType = ProductSubType;
	@ViewChild("payment", { static: false }) payment: PaymentComponent;
	@ViewChild('paypal', { static: false }) paypalElement: ElementRef;

	constructor(
		public ssosvc: acepglobal.AcepSSOService,
		public globaldomops: acepglobal.GlobalDomOpsService,
		public globaldataops: acepglobal.GlobalDataOpsService,
		public dataService: DataService,
		public memberAppDataService: MemberAppDataService,
		private commonOpsService: acepglobal.CommonOperationsService,
		private checkoutService: CheckoutService,
		private myAccountDataService: MyAccountDataOpsService,
		public paymentservice: PaymentService,
		public emailHelperService: EmailHelperService,
		public loggerService: LoggerService
	) {
		//super(ssosvc, globaldomops, globaldataops, authHttp);
		// this.orderdetails.orderLineItems[0].ProductSubType = ProductSubType.

		//subject for updating order when line items or donations are updated
		this.modelChanged
			.pipe(
				debounceTime(300))
			.subscribe(() => {
				this.updateOrder();
			})
	}

	ngOnInit() {
		this.initdata();
	}

	ngAfterViewInit() {
		//Moved to view child because payment viewchild is not available in onint
		// https://stackoverflow.com/questions/34947154/angular-2-viewchild-annotation-returns-undefined

		if (this.payment) {
			this.globaldomops.showwait();
			this.globaldomops.continueToWait = true;

			this.paymentservice.uidata.Countries = this.dataService.uidata.Countries;
			this.paymentservice.uidata.StateProvinces = this.dataService.uidata.StateProvinces;

			this.paymentservice.paypalElement = this.paypalElement;

			this.isGraduatingResidentOrFellow = this.memberAppDataService.CheckIfEligibleForRegYR123();

			this.isRegYR123 = this.memberAppDataService.memberAppData.profile.IsRegYR123;


			this.checkoutService.AddPaymentUIConfiguration();

			if (!this.isGraduatingResidentOrFellow) {
				this.callCalculateOrder(true);
			}
			else {
				//GRADUATING RESIDENTS 
				//The following call makes 2 calls to calculate order one for each rates; RegYR123 and RegYR1
				this.checkoutService.getGraduatingResidentItems().subscribe((res: GraduatingResidentOption[]) => {
					this.gresOptions = res;
					this.refreshUI_graduatingResidents_basedOnRate(true);
				})
			}



			// this.payment.initPaymentComponent();
		}
	}

	refreshUI_graduatingResidents_basedOnRate(isPageLoad: boolean) {

		// this.paymentservice.paymentuiconfig.SHOWINSTALLMENTS = false;
		// this.paymentservice.paymentuiconfig.LOCKAUTORENEWAL = this.isRegYR123;
		// this.paymentservice.paymentuiconfig.SHOWPROMOCODE = !this.isRegYR123;
		this.paymentservice.paymentuiconfig.SHOWPROMOCODEAPPLIED = !this.isRegYR123;
		this.paymentservice.paymentuiconfig.AUTORENEWALINFOLABEL = "Members who select monthly payment option are enrolled in the auto renewal program.";;

		let res = this.isRegYR123 ? this.gresOptions[0].res : this.gresOptions[1].res;
		this.orderdetails = this.isRegYR123 ? this.gresOptions[0].OrderDetails : this.gresOptions[1].OrderDetails;
		this.paymentservice.orderdetails = this.orderdetails;
		this.paymentservice.MapValidationOrderDetails(res);
		if (isPageLoad) {
			this.payment.initPaymentComponentExternal(res);
			//the following is a band aid because calculateorder is not deducting EAAL price from total amount because it 
			//is included the line items but it has to not be selected by default as per business. MB 10/9/2024
			if (this.isRegYR123) {
				let EEAL = this.orderdetails.orderLineItems.find(a => a.ProductNumber == 'EEAL-MTHLY3YR');
				if (!!EEAL) {
					EEAL.ProductName = 'EMRA Alumni National Dues';
					let EEALPRICE = EEAL.UnitPrice;
					EEAL.Selected = false;
					this.orderdetails.TotalAmount = this.orderdetails.TotalAmount - EEALPRICE;
				}

				let EAAL = this.gresOptions[1].OrderDetails.orderLineItems.find(a => a.ProductNumber == 'EAAL');
				if (!!EAAL) {
					let EAALPRICE = EAAL.UnitPrice;
					EAAL.Selected = false;
					this.gresOptions[1].OrderDetails.TotalAmount = this.gresOptions[1].OrderDetails.TotalAmount - EAALPRICE;
				}
			}


		}



		this.globaldomops.hidewait();


	}

	syncPrimaryEmployerAcrossOptional(newValue: string) {
		// sync the new Primary Employer value to PAC and NEMPAC product orderlines
		this.orderdetails.orderLineItems
		  .filter(item => item.ProductSubType === ProductSubType.PAC || item.ProductSubType === ProductSubType.NEMPAC )
		 .forEach((item:any) => item.PrimaryEmployer = newValue);
	  }

	changeGraduatingResidentRate() {
		this.globaldomops.showwait();

		//assign the current order details to gresOptions item
		if (!this.isRegYR123) { //this is bcos by this time the value is already changed
			this.gresOptions[0].OrderDetails = this.orderdetails;
		}
		else {
			this.gresOptions[1].OrderDetails = this.orderdetails;
		}



		//update the opted out flag which will internally also call progression
		//WHYYYY????
		//this.memberAppDataService.memberAppData.profile.IsRegYR123 = this.isRegYR123;
		this.refreshUI_graduatingResidents_basedOnRate(false);




	}

	callCalculateOrder(isPageLoad: boolean) {
		this.checkoutService
			.CalculateOrder(this.memberAppDataService.memberAppData)
			.subscribe(
				(res: any) => {
					this.handleOrderGenErrors();
					this.orderdetails = this.paymentservice.orderdetails;
					this.paymentservice.MapValidationOrderDetails(res);
					this.payment.initPaymentComponentExternal(res);
					if (isPageLoad) {
						this.handleEMRAProration(res);
						//this.handleGraduatingResidents(false);
					}
					this.globaldomops.hidewait();
				},
				error => {
					this.memberAppDataService.notify(
						NotificationStatus.Error
					);
				},
				() => { this.globaldomops.hidewait(); }
			);
	}



	handleEMRAProration(res: any) {
		//let isAFormerMember = this.myAccountDataService.myaccountdata.membershipInfo.isAFormerMember;
		let isAFormerMember = this.memberAppDataService.memberAppData.profile.allMemberships?.find(m => m.PaidThroughDate != null) != null;
		let month = new Date().getUTCMonth() + 1;
		//if (this.globaldataops.ORG == "EMRA" || this.globaldataops.ORG == "ACEPEMRA") {
		if ([MemberType.Student, MemberType.Resident, MemberType.Fellow].indexOf(this.memberAppDataService.memberAppData.membershipDetails.memberType) > -1
			&& month != 7 //JULY
			&& !isAFormerMember) {
			this.isEMRAProRateMode = true;
			this.paymentservice.paymentuiconfig.SHOWINSTALLMENTS = false;
			this.cycleStartDate = this.commonOpsService.SantizeDate(res.cycleStartDate);
			this.cycleEndDate = this.commonOpsService.SantizeDate(res.expirationDate);
		}
		//}
	}

	handleOrderGenErrors() {
		if (this.paymentservice.orderdetails.orderLineItems.length == 0) {
			this.memberAppDataService.notify(NotificationStatus.Error);
			this.loggerService.logError(
				"No Order Line Items obtained from Calculate Order Web Service call"
			);
		}
	}

	changed_optional_cb(e: any, li: LineItem) {
		li.Selected = e.target.checked;
		this.changed();
	}

	changed() {
		this.modelChanged.next();
	}

	updateTotalAmountOfOrderBasedOnLineItems(ol: OrderDetails) {
		ol.TotalAmount = 0;
		ol.orderLineItems.forEach(li => {

			if (!!!li.UnitPrice) li.UnitPrice = 0;

			if (li.Modifiable) {
				li.UnitPrice = li.Selected ? li.UnitPrice : 0;
			}
			//li.UnitPrice = parseFloat(li.UnitPrice).toFixed(2);
			if (li.Selected) {
				ol.TotalAmount += +li.UnitPrice;
			}
		});
	}

	updateOrder() {

		this.updateTotalAmountOfOrderBasedOnLineItems(this.orderdetails);


		this.payment.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS = this.orderdetails.TotalAmount;

		if (!!(this.orderdetails.PromoCode) && !(this.orderdetails.IsTrialMembership)) {
			this.ApplyPromoCode();
		}


		if (this.isGraduatingResidentOrFellow) {

			//update optional products(sections selcted property)
			let thisSvc = this;
			this.orderdetails.orderLineItems.forEach(e => {
				let e0 = thisSvc.gresOptions[0].OrderDetails.orderLineItems.find(a => a.ProductNumber == e.ProductNumber);
				let e1 = thisSvc.gresOptions[1].OrderDetails.orderLineItems.find(a => a.ProductNumber == e.ProductNumber);

				if (!!e0) {
					e0.Selected = e.Selected;
				}
				if (!!e1) {
					e1.Selected = e.Selected;
				}
			});




			if (this.isRegYR123) {
				this.gresOptions[0].OrderDetails = this.orderdetails;

				//Update the Annual Tab total amount based on optional product selections
				this.updateTotalAmountOfOrderBasedOnLineItems(this.gresOptions[1].OrderDetails);


			}
			else {
				this.gresOptions[1].OrderDetails = this.orderdetails;
			}


		}


	}

	updatePriceFormat() {
		this.orderdetails.orderLineItems.forEach(li => {
			li.UnitPrice =
				li.UnitPrice == "" ? 0.0 : parseFloat(li.UnitPrice).toFixed(2);
			this.orderdetails.TotalAmount += +li.UnitPrice;
		});
	}

	initdata() {
		//this.paymentservice.paymentWebServicePath = 'http://localhost:50003/api/orders/';

		this.orderdetails = this.memberAppDataService.memberAppData.orderDetails = new OrderDetails();
		this.termsAndConditionsText = this.memberAppDataService.getContentSnippet(
			`MEMBERAPPLICATION_TERMSANDCONDITIONS_${this.globaldataops.GetORG()}`
		);

	}
	//ACCEPT OUTPUT METHODS FROM PAYMENT COMPONENT //
	updatePaymentSummary(_paysummary: PaymentSummary) {
		this.paymentsummary = _paysummary;
		this.orderdetails.TotalAmount = this.paymentsummary.TOTALAMOUNTWITHTAXESANDDISCOUNTS;
	}

	runNotificationsForFailedOrder() {
		if (this.isGraduatingResidentOrFellow) {
			//then reset the optoutRegyr123 flag
			this.memberAppDataService.UpdateOptOutRegYR123Flag(false).subscribe(() => {
				this.globaldomops.hideWaitIfNoXHRInProgress();
			});

		}
	}

	OrderProcessingCompleted(response: any) {

		if (!!!response) {
			//PAYMENT FAILED TO PROCESS.  MB 8/1/2024
			this.runNotificationsForFailedOrder();
			return;
		}

		this.globaldomops.notify(
			"Congratulations. Your order has been placed successfully"
		);

		//FB Pixel Code: MOhan and Darryn 4/19/2019
		//https://jira.acep.org/browse/ACEPWEB-884
		if (!this.globaldataops.isTestEnvironment()) {
			window.open(`${this.globaldataops.BasePath}/analytics/memberapp.htm`);
		}

		this.runAnalytics();


		this.orderdetails = this.payment.od;
		this.orderdetails.OrderId = response;
		this.maskedccnum = this.paymentservice.MaskCreditCardNumber(
			this.orderdetails.PaymentInformation.CreditCardNumber
		);
		//the following 2 thigns are obtained by an extra call after order proceesed in ninja iinterface for place order
		this.orderNumber = this.memberAppDataService.memberAppData.notifyInfo.orderNumber = this.paymentservice.orderNumber;
		this.orderdetails.TotalAmount = this.paymentservice.orderdetails.TotalAmount;
		this.memberAppDataService.memberAppData.orderDetails = this.paymentservice.orderdetails;
		//this.payment.pconfig.PAYMENTSUMMARY.TOTALAMOUNTWITHTAXESANDDISCOUNTS;

		//take the use to receipt page
		this.memberAppDataService.notify(
			this.memberAppDataService.memberAppData.profile.membership
				.IsOnAutoRenewal
				? NotificationStatus.RenewalSuccesful
				: NotificationStatus.NewMembershipSuccessful
		);

		//Send Manual institution emails
		this.emailHelperService.SendManualEmailContentIfAny(
			this.memberAppDataService.memberAppData
		);
		//Run Order Recpt Workflow
		this.emailHelperService.RunOrderReceiptWorkflow(
			this.memberAppDataService.memberAppData
		);
	}


	submitpayment(event) {
		event.stopPropagation();
		this.payment.SynchDataFromChildComponents();
		if (this.globaldomops.CheckValidations(event)) {
			//this.paymentservice.OpenPaymentPreview();

			//Update order line items--pass only the ones that are marked selected
			//this.UseOnlySelectedLineItems();



			//Update OrgCode on Orderdetails from ACEP to ACEPEMRA if EMRA Alumni product is present
			//MB 10/10/2024
			///this.orderdetails.OrgCode = (this.orderdetails.orderLineItems.find(a => a.ProductName.indexOf('Alumni') > -1) != null) ? OrgCode.ACEPEMRA : OrgCode.ACEP;






			if (this.isGraduatingResidentOrFellow) {
				this.memberAppDataService.UpdateOptOutRegYR123Flag(!this.isRegYR123).subscribe(() => {
					this.payment.PlaceOrder();
					this.globaldomops.hideWaitIfNoXHRInProgress();
				});
			}
			else {
				this.payment.PlaceOrder();
			}




		}

		return false;
	}

	// UseOnlySelectedLineItems()
	// {
	//   //Update line items in main order
	//   let odDeepCopy: OrderDetails = this.commonOpsService.DeepCopyObject(this.paymentservice.orderdetails);
	//   odDeepCopy.orderLineItems =  odDeepCopy.orderLineItems.filter(a=>a.Selected);
	//   this.payment.od.orderLineItems = this.paymentservice.orderdetails.orderLineItems = odDeepCopy.orderLineItems;
	// }

	ApplyPromoCode() {
		this.paymentservice.ApplyPromoCode().subscribe(
			(response: any) => {
				if (response.promoCodeValid) {
					this.globaldomops.notify("Promo Code Applied!!");
					this.paymentsummary = {
						TOTALDISCOUNT: response.totalDiscount,
						TOTALTAXES: response.totalTaxes,
						TOTALAMOUNTWITHTAXESANDDISCOUNTS: response.totalAmount,
						PROMOCODEMESSAGE: response.promoMsg,
						TOTALSHIPPING: response.totalShipping
					};

					this.payment.pconfig.PAYMENTSUMMARY = this.paymentsummary;
					if (this.isGraduatingResidentOrFellow) {
						this.orderdetails.TotalAmount = this.paymentsummary.TOTALAMOUNTWITHTAXESANDDISCOUNTS;
					}

				} else {
					this.globaldomops.notify(
						`Invalid ${this.paymentservice.paymentuiconfig.PRMOCODELABEL
						}!!`,
						"",
						"error"
					);
				}
			},
			error => {
				this.ssosvc.CheckAuthorizationOnResponse(error);
				this.globaldomops.notify(
					"Promo Code Could not apply!!",
					"",
					"error"
				);
			},
			() => {
				this.globaldomops.hidewait();
			}
		);
	}

	printReceipt() {
		this.paymentservice.printReceipt();
	}

	runAnalytics() {
		let isAFormerMember = this.memberAppDataService.memberAppData.profile.allMemberships?.find(m => m.PaidThroughDate != null) != null;

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'MembershipApplicationCompleted',
			'productName': isAFormerMember ? 'Renewal' : 'New Membership',
			'registrationValue': this.paymentservice.orderdetails.TotalAmount,
			'acepid': this.ssosvc.acepid
		});
	}

	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		this.subscriptions.forEach((subscription: Subscription) => {
			subscription.unsubscribe();
		});
	}
}
